/**
 * Left Panel Component - Collapsible Sidebar
 *
 * Monitoring panels:
 * - Like Gauge Panel
 * - TikTok Test Panel
 * - Comment History Panel
 */

import React, { Suspense, lazy, useState } from 'react';
import './LeftPanel.css';

// Lazy load panels for better performance
const LikeGaugePanel = lazy(() => import('@/hooks/react/components/LikeGaugePanel.js'));
const TikTokTestPanel = lazy(() => import('@/hooks/react/components/tiktok-test-panel/index.js'));
const EnhancedCommentHistoryPanel = lazy(() => import('@/hooks/react/components/EnhancedCommentHistoryPanel.js'));

const PanelFallback: React.FC = () => (
    <div className="panel-loading">読み込み中...</div>
);

// Toggle button icon
const ChevronIcon: React.FC<{ direction: 'left' | 'right' }> = ({ direction }) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ transform: direction === 'left' ? 'rotate(0deg)' : 'rotate(180deg)' }}
    >
        <polyline points="15 18 9 12 15 6" />
    </svg>
);

export const LeftPanel: React.FC = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <div className={`left-panel control-panel sidebar ${isCollapsed ? 'sidebar--collapsed' : ''}`}>
            {/* Toggle Button */}
            <button
                className="sidebar-toggle sidebar-toggle--left"
                onClick={() => setIsCollapsed(!isCollapsed)}
                aria-label={isCollapsed ? 'サイドバーを開く' : 'サイドバーを閉じる'}
            >
                <ChevronIcon direction={isCollapsed ? 'right' : 'left'} />
            </button>

            {/* Sidebar Header */}
            <div className="sidebar-header">
                <h2 className="sidebar-title">Monitor</h2>
            </div>

            {/* Panel Content */}
            <div className="panel-content sidebar-content">
                <Suspense fallback={<PanelFallback />}>
                    <div className="panel-section">
                        <LikeGaugePanel />
                    </div>
                </Suspense>

                <Suspense fallback={<PanelFallback />}>
                    <div className="panel-section">
                        <TikTokTestPanel />
                    </div>
                </Suspense>

                <Suspense fallback={<PanelFallback />}>
                    <div className="panel-section">
                        <EnhancedCommentHistoryPanel />
                    </div>
                </Suspense>
            </div>
        </div>
    );
};

export default LeftPanel;
